module.exports = __webpack_public_path__ + "img/icons8-present-100.a1c984c0.png";